import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

// Salvar no storage
import { Storage } from '@ionic/storage';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

import { TabsPage } from '../tabs/tabs';


@Component({
    selector: 'page-register',
    templateUrl: 'register.html',
})



export class RegisterPage {

    createSuccess = false;
    registerCredentials = { email: '', senha: '', nome: '', whatsapp: '' };
    imagem: string;

    constructor(private _apiService: ApiProvider, public loadingCtrl: LoadingController, private alertCtrl: AlertController, public nav: NavController, private storage: Storage, private _msg: TranslateMsgProvider)
    {
        this._apiService.getLogo().subscribe(arg => {
            this.imagem = arg.config.imagem;
        });
    }


    /* Main */
    public register() {
        var emailTest = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        /* Verifica se não está null*/
        if (this.registerCredentials.email === null || this.registerCredentials.senha === null || this.registerCredentials.nome === null || this.registerCredentials.whatsapp === null) {
            this.showPopup("Error", this._msg.getMsg('ERRO_DADOS'));
        } 
        /* Verifica se o email é valido */
        else if(!emailTest.test(this.registerCredentials.email))
        {
            this.showPopup("Error", this._msg.getMsg('ERRO_EMAIL'));
        }
        else
        {
            let loader = this.loadingCtrl.create({
                content: this._msg.getMsg('CARREGANDO')+"..."
            });
            loader.present();

            this._apiService.cadastro(this.registerCredentials).subscribe(arg => {
                // console.log(arg);
                loader.dismiss();

                // Cadastrou
                if((arg>0)&&(arg!==false))
                {
                    this.createSuccess = true;

                    this.storage.set('id_cliente', arg);
                    this.storage.set('nome', this.registerCredentials.nome);
                    
                    this.showPopup(this._msg.getMsg('SUCESSO'), this._msg.getMsg('SUCESSO_CONTA'));
                }
                else
                {
                    // Erro
                    let alert = this.alertCtrl.create({
                        title: this._msg.getMsg('ERRO')+'!',
                        message: arg.erro,
                        buttons:
                            [{
                                text: 'Ok',
                            }]
                    });
                    alert.present();
                }
            });
        }
    }

    /* Exibe as mensagens de erro ou sucesso */
    showPopup(title, text) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: text,
            buttons: [
            {
                text: 'OK',
                handler: data => {
                    alert.dismiss();
                    if (this.createSuccess) {
                        this.nav.setRoot(TabsPage);
                    }
                }
            }
            ]
        });
        alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts